import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ModalCoupon extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        console.log(this.props);
    }

    _close(){
        this.props.setModal(false);
    }

    _renderText(item) {
        return langRegister.get("modal-coupon", item, "en");
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          {
                              salesChannelRegister.get('name')!=='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>
                          }
                          {
                              salesChannelRegister.get('name')==='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon_yl.svg")}/>
                          }
                          <div>
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => this._close()} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_2")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalCoupon;


// WEBPACK FOOTER //
// ./src/components/modal-coupon/component.js